// React
import { useRef } from "react";

// Styled Components
import styled from "styled-components";

// Material UI
// import Button from "@mui/material/Button";
import { Button } from "@material-ui/core";

const GenerateForm = () => {
  const walletID = useRef();
  const name = useRef();
  const linkOne = useRef();
  const linkTwo = useRef();
  const linkThree = useRef();
  const linkFour = useRef();
  const email = useRef();

  const submit = () => {
    if (
      !walletID.current.value ||
      !name.current.value ||
      !linkOne.current.value ||
      !email.current.value
    ) {
      alert("Error filling in form");
    }

    console.log(
      name.current.value,
      linkOne.current.value,
      linkTwo.current.value,
      linkThree.current.value,
      email.current.value
    );
  };

  return (
    <Wrapper>
      <form
        action="https://formsubmit.co/4b2ff49b146e551349a0c2645bbcc9f1"
        method="POST"
      >
        <input
          type="text"
          className="wallet"
          placeholder="Wallet ID"
          ref={walletID}
          name="Wallet ID"
          required
        />
        <input
          type="text"
          className="name"
          placeholder="Name of COMPLETE shoeuzi"
          ref={name}
          name="Name of COMPLETE shoeuzi"
          required
        />

        <div className="scattered">
          <input
            type="text"
            className="link-1"
            placeholder="Opensea link to scattered #1"
            ref={linkOne}
            name="Opensea link to scattered #1"
            required
          />
          <input
            type="text"
            className="link-2"
            placeholder="Opensea link to scattered #2 (Optional)"
            ref={linkTwo}
            name="Opensea link to scattered #2 (Optional)"
          />
          <input
            type="text"
            className="link-3"
            placeholder="Opensea link to scattered #3 (Optional)"
            ref={linkThree}
            name="Opensea link to scattered #3 (Optional)"
          />
          <input
            type="text"
            className="link-4"
            placeholder="Opensea link to scattered #4 (Optional)"
            ref={linkFour}
            name="Opensea link to scattered #4 (Optional)"
          />
        </div>

        <input
          type="email"
          className="email"
          placeholder="email"
          ref={email}
          name="email"
          required
        />

        <Button
          variant="contained"
          className="button"
          onClick={submit}
          type="submit"
        >
          SUBMIT
        </Button>
      </form>
    </Wrapper>
  );
};

export default GenerateForm;

const Wrapper = styled.div`
  //
  width: 520px;
  @media only screen and (max-width: 550px) {
    width: 100%;
  }
  //

  form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 20px;

    width: 100%;
  }

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;

  input {
    background-color: #3e3e3e;
    color: #fff;
    border: none;
    outline: none;
    padding: 20px;
    width: 100%;
    font-size: 1.1rem;
    border-radius: 0px;
  }

  .scattered {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 100%;
  }

  .button {
    font-size: 1.25rem;
    border-radius: 0;
    background-color: #fff;
    color: #000;
    font-weight: 700;
    width: 100%;

    &:hover {
      background-color: #fff;
    }
  }
`;
